import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder", "value"]

interface Props {
  placeholder?: string
  modelValue?: string | number
}

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    placeholder: { default: '' },
    modelValue: { default: '' }
  },
  setup(__props: any) {

const props = __props as { placeholder: string, modelValue: string | number }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", _mergeProps(_ctx.$attrs, {
    placeholder: props.placeholder,
    value: __props.modelValue,
    onInput: _cache[0] || (_cache[0] = (e) => _ctx.$emit('update:modelValue', (e.target as HTMLInputElement).value.trim()))
  }), null, 16, _hoisted_1))
}
}

})